import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { trackingOnboardingLoaderView } from 'services';
import styles from './LoaderCode.module.scss';
import classNames from 'classnames';

interface LoaderCodeProps {
  className?: string;
}

export const LoaderCode: React.FC<LoaderCodeProps> = (props) => {
  const { className } = props;
  const history = useHistory();

  useEffect(() => {
    trackingOnboardingLoaderView();
    const timeout = window.setTimeout(() => {
      history.push('/onboarding/connect-apps');
    }, 14000);

    return () => window.clearTimeout(timeout);
  }, [history]);

  return (
    <div className={styles.publicLoader}>
      <div className={classNames(className, styles.container)}>
        <div className={styles.wrap}>
          <div>
            <h2 className={styles.text}>
              <span className={styles.normalText}>Securing access to your documents&hellip; </span>
              <span className={styles.shortText}>Securing document access&hellip; </span>
              <span className={styles.done}>Done.</span>
            </h2>
          </div>
        </div>

        <div className={styles.wrap}>
          <div>
            <h2 className={styles.text}>
              <span className={styles.normalText}>
                Enabling quick access to most frequently used documents&hellip;{' '}
              </span>
              <span className={styles.shortText}>Enabling quick retrieval&hellip; </span>
              <span className={styles.done}>Done.</span>
            </h2>
          </div>
        </div>

        <div className={styles.wrap}>
          <div>
            <h2 className={styles.text}>
              <span className={styles.normalText}>Encrypting document metadata&hellip; </span>
              <span className={styles.shortText}>Encrypting metadata&hellip; </span>
              <span className={styles.done}>Done.</span>
            </h2>
          </div>
        </div>

        <div className={styles.wrap}>
          <div>
            <h2 className={styles.text}>
              <span className={styles.normalText}>
                Verifying exclusive access to your private documents&hellip;{' '}
              </span>
              <span className={styles.shortText}>Verifying private access&hellip; </span>
              <span className={styles.done}>Done.</span>
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoaderCode;
